import { MemberAdditionalDocumentDTO } from '../../services/apiClient';
import { TableAction } from '../common/Table';
import { Download, Search, Trash2 } from 'lucide-react';

interface MemberAdditionalDocumentActionHandlers {
    onView: (memberAdditionalDocument: MemberAdditionalDocumentDTO) => void;
    onDelete: (memberAdditionalDocument: MemberAdditionalDocumentDTO) => Promise<void>;
    onDownload: (memberAdditionalDocument: MemberAdditionalDocumentDTO) => Promise<void>;
}

const createMemberAdditionalDocumentActions =
    (handlers: MemberAdditionalDocumentActionHandlers) =>
        (row: MemberAdditionalDocumentDTO): TableAction[] => {
            const actions: TableAction[] = [];

            actions.push({
                label: 'View Document',
                onClick: () => handlers.onView(row),
                icon: <Search className="w-4 h-4" />,
            });
            actions.push({
                label: 'Delete Document',
                onClick: () => handlers.onDelete(row),
                icon: <Trash2 className="w-4 h-4" />,
                confirmMessage: 'Are you sure you want to delete this document?',
                className: 'text-red-600 hover:text-red-700',
            });
            actions.push({
                label: 'Download Document',
                onClick: () => handlers.onDownload(row),
                icon: <Download className="w-4 h-4" />,
            });

            return actions;
        };

export default createMemberAdditionalDocumentActions;
